// angular imports
import { Component, Injector, OnInit } from '@angular/core';

// component imports
import { WorkOrderManageTaskBaseComponent } from '../../../_base/work-order-manage-task-base-component';

// model imports
import { ClosedWorkOrderBaseParameterDto } from '../../../_models/closed-work-order-invoice-parameter-dto';
import { ProjectTaskWorkOrderLinkResultDto } from '../../../_models/project-task-work-order-link-result-dto';

@Component({
    selector: 'app-manage-closed-tasks',
    templateUrl: './manage-closed-tasks.component.html',
    styleUrls: ['./manage-closed-tasks.component.scss']
})
export class ManageClosedTasksComponent extends WorkOrderManageTaskBaseComponent implements OnInit {
    numberOfDays = 90;
    closedTasks: Array<ProjectTaskWorkOrderLinkResultDto> = [];

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.populateClosedTasks();
    }

    onForceReload(): void {
        this.populateClosedTasks();
    }

    private populateClosedTasks(): void {
        const baseParams: ClosedWorkOrderBaseParameterDto = new ClosedWorkOrderBaseParameterDto();
        baseParams.workOrderId = this.workOrderId;
        baseParams.communityId = this.communityId;
        baseParams.numberOfDays = this.numberOfDays;

        this.workOrderHelperService.showLoading();
        this.workOrderService.getClosedTasks(baseParams).subscribe(
            (result: ProjectTaskWorkOrderLinkResultDto[]) => {
                this.closedTasks = result;
                this.workOrderHelperService.hideLoading();
            },
            (error) => {
                this.workOrderHelperService.hideLoading();
                this.errorService.displayError(error);
            }
        );
    }
}
